















import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { ComplainModel } from '@/models/complain';

import ListComplain from './components/ListComplain.vue';
import FilterBox from './components/FilterBox.vue';

import authService from '@/services/auth-services';
import complainServices from '@/services/complain-services';
import formatNumber from '@/shared/filters/format-number';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListComplain,
        FilterBox,
        Loading,
        Paging,
    }
})
export default class ListItem extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
        rowPerPage: 15,
        pageSize: 6,
        pageIndex: 1,
        total: 0,
    };
    private listItem: ComplainModel[] = [];
    private isLoading = false;
    private isShowModal = false;
    private customerInfo: any = {};

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        await this.getCustomersInfo();
        this.loadData();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        const result = await complainServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpList: ComplainModel[] = [];
            this.pageSettings.total = result.data.total;
            for (const item of result.data.data) {
                const complain = new ComplainModel();
                complain.ID = item.ID;
                complain.UID = item.UID;
                complain.Username = item.Username;
                complain.Status = item.Status;
                complain.OrderID = item.OrderID;
                complain.OrderType = item.OrderType;
                complain.Amount = item.Amount;
                complain.AmountNDT = item.AmountNDT;
                complain.Img = item.Img;
                complain.Files = item.Files;
                complain.TransactionCode = item.TransactionCode;
                complain.ComplainText = item.ComplainText;
                complain.CreatedDate = item.CreatedDate;
                complain.SndOrderID = item.SndOrderID;
                complain.SndOrderType = item.SndOrderType;
                complain.ResMethod = item.ResMethod;
                complain.StatusDetail = DATA.complainStatusList.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                tmpList.push(complain);
            }
            this.listItem = tmpList;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'ComplainText',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'OrderID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }
}
